import { FieldPath, useFormContext } from 'react-hook-form'
import Button from '@Components/Buttons/Button'
import React, { JSX } from 'react'
import { computed } from 'mobx'
import './index.scss'
import SearchCriteriaStore from '@App/stores/search/search-criteria-store'
import clsx from 'clsx'
import { SearchWithCriteriaFormType } from '@Components/Search/SearchWithCriteria/form-type'

interface SearchControlSectionProps {
    searchCriteriaStore: SearchCriteriaStore<any>
    resetSearchFn?: () => void
    disableSearchButtons?: boolean
    extraButtons?: JSX.Element[]
}

const SearchControlSection = <K extends object>(props: SearchControlSectionProps) => {
    const { searchCriteriaStore, resetSearchFn, disableSearchButtons, extraButtons } = props

    const { watch } = useFormContext<SearchWithCriteriaFormType<K>>()
    const searchValues = watch('search', [])
    const filterValues = watch('filter' as FieldPath<SearchWithCriteriaFormType<K>>, undefined) as K

    const isResetButtonDisabled = computed(() => {
        if (disableSearchButtons) {
            return true
        }
        if (searchCriteriaStore.searchCriteria.length > searchCriteriaStore.defaultSearchCriteriaLength) {
            return false
        }
        return !searchCriteriaStore.isCriteriaSearchReady(searchValues, filterValues)
    })

    return (
        <div className="button-wrapper">
            <div className="criteria-buttons">
                {resetSearchFn && (
                    <a
                        className={clsx('link bold', isResetButtonDisabled.get() && 'disabled')}
                        type="secondary"
                        onClick={isResetButtonDisabled.get() ? undefined : resetSearchFn}
                    >
                        Reset Search
                    </a>
                )}
                {extraButtons && (
                    <div className="extra-button-wrapper">{extraButtons.map((extraButton) => extraButton)}</div>
                )}
                <Button
                    submitType="submit"
                    mainColor
                    className="control-button search"
                    type="primary"
                    disabled={
                        disableSearchButtons || !searchCriteriaStore.isCriteriaSearchReady(searchValues, filterValues)
                    }
                >
                    Search
                </Button>
            </div>
        </div>
    )
}

export default SearchControlSection
